import "jquery.cookie"

class Location {
// Location
    constructor(user_id, then) {
        var that = this;
        var settings = $.cookie(`user_${user_id}_location`)


        if (!settings){
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((data) => {
                        that.setLocation(user_id, data.coords.latitude, data.coords.longitude);

                        if (then) {
                            then({ status: true, latitude: data.coords.latitude, longitude: data.coords.longitude });
                        }
                    },
                    (error) => {
                        if (then) {
                            then({ status: false });
                        }
                    },

                    { timeout: 15000 }
                );
            }
            else {
                if (then) {
                    then({ status: false });
                }
            }
        }
    }

    setLocation(user_id, lat, lng) {
        var that = this;
        $.ajax({
            url: "/profile/change-location-geoip/",
            dataType: 'json',
            type: 'post',
            data: {
                accept: 1,
                home: 0,
                latitude: lat,
                longitude: lng
            },
            success: function(data) {
                var settings = {
                    location: {
                        lat: lat,
                        lng: lng
                    }
                };

                var expDate = new Date();
                expDate.setTime(expDate.getTime() + (30 * 60 * 1000));
                $.cookie(`user_${user_id}_location`, JSON.stringify(settings), {expires: expDate, path: "/"});

                if (data.cityId != that.cityId) {
                    window.location.reload();
                }
            }
        });
    }

    goipPrompt(country, city, lat, lng, text, homeText, acceptText, ignoreText) {
        bootbox.confirm(
            `<div class='location-image' style='background-image: url(http://maps.googleapis.com/maps/api/staticmap?center=${lat + 0.004},${lng}&zoom=12&size=600x150&markers=color:red%7C${lat},${lng});'></div><div class='location-fix'></div>${text}<label><input id='geoip_home_checkbox' class="custom" type="checkbox"><span></span>${homeText}</label>`,
            ignoreText,
            acceptText,
            function(result) {
                if (result) {
                    var home = $("#geoip_home_checkbox").attr("checked") ? 1 : 0;
                    $.ajax({
                        url: "/profile/change-location-geoip/",
                        dataType: 'json',
                        type: 'post',
                        data: {accept: 1, home: home},
                        success: function(data) {window.location.reload();}
                    });
                } else {
                    $.ajax({
                        url: "/profile/change-location-geoip/",
                        dataType: 'json',
                        type: 'post',
                        data: {accept: 0},
                        success: function(data) {}
                    });
                }
        });
    }
}

export { Location }
